import React, { useEffect, useRef, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { VALIDATE } from "../utils/Validators";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { useGlobals } from "../hooks/Globals";
import { setSignal } from "../App";
import Checkbox from "../ui/Checkbox";

export default function EmployeeLogin(props) {

    const { controller = "", signal = {}, route = "", callback = () => { }, permission = false, login = true, can_login = false } = props;

    const [init, setInit] = useState(true);
    const [id, setId] = useState(null);
    const [remember, setRememeber] = useState(false);

    const refs = useRef([]);
    const [index, setIndex] = useState("code");

    useEffect(() => {

        if(!can_login){
            return; 
        }
        refs.current[index].focus()
    }, [index])

    const onLogin = (_force = false) => {

        if (!id) {
            return;
        }

        if (!login) {
            if (can_login && remember) {
            } else {
                callback(id);
                return;
            }
        }

        let _obj = {
            clerk_code: id,
            force_match: _force
        }

        if (permission) {
            _obj.permission_checks = permission;
        }

        pubCall("employee.login", _obj, (_s, _r) => {
            if (_s) {
                setSignal({ ...signal.value, "session": _r })
                showMessage(_r.clerk_code + " is now logged in");
                callback(_r);
            } else {
                if (_force) {
                    showError(_r)
                }
            }
        })
    }

    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { onLogin(true) } },
        { key: KBD.ARROW_DOWN, action: () => { (index === "keep") ? setIndex("code") : setIndex("keep") } },
        { key: KBD.ARROW_UP, action: () => { (index === "keep") ? setIndex("code") : setIndex("keep") } },
        { key: KBD.TAB, action: () => { (index === "keep") ? setIndex("code") : setIndex("keep") } },
        { key: KBD.SHIFT_TAB, action: () => { (index === "keep") ? setIndex("code") : setIndex("keep") } },
    ]

    useEffect(() => {
        if (id) {
            onLogin(false)
        }
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB]);
        return cleanup;
    }, [actions, id, index])


    return (
        <>
            <div style={{ "width": "154px" }}>
                <div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Enter your ID</Label><Divider vertical />
                    <Input ref={(el) => (refs.current["code"] = el)} controlled={true} style={{ "textAlign": "center" }} onChange={(e) => setId(e)} uppercase autofocus maxLength={2} autoselect placeholder="" width={40} edit value={id} />
                </Space>
                {(can_login && <div><Checkbox ref={(el) => (refs.current["keep"] = el)} value={remember} onChange={() => setRememeber(!remember)} ><Label>Keep me logged in?</Label></Checkbox></div>)}
            </div>
            {/* <small><pre>{JSON.stringify(signal.value, null, 2)}</pre></small> */}
        </>
    )
}